import { NotFound } from 'src/components/shared';
import { getCssVariable } from 'src/utils/utils';
import Layout from './Layout';

const PageNotFound = () => {
  const primaryColor = getCssVariable('--primary-color');

  return (
    <Layout
      style={{
        color: primaryColor,
      }}
      hamburgerStyle={{
        backgroundColor: primaryColor,
      }}
      saleClassName={'btn-gradient-bdr'}
      headerStyle={{ position: 'relative' }}
    >
        <NotFound />
    </Layout>
  );
};

export default PageNotFound;
